/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.10.6",
    versionName: "0.7.0-nightly.2026.10.6",
    versionChannel: "nightly",
    buildDate: "2026-10-06T00:17:12.153Z",
    commitHash: "5e6f614fa5495f32330c7f5c4df87599a4462ea4",
};
